module.exports = __webpack_public_path__ + "img/file-ppt.67ede7e1.svg";